<template>
  <v-container>
    <v-row>
      <v-col cols="12">
        <div>
          <v-data-table
            :headers="headers"
            :items="simposiums"
            item-key="name"
            class="elevation-1"
            @click:row="openSimposium"
          >
          </v-data-table>
        </div>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
export default {
  props: {
    simposiums: {
      type: Array
    }
  },
  computed: {
    headers() {
      return [
        {
          text: this.$t("program"),
          align: "start",
          sortable: false,
          value: "name"
        },
        {
          text: this.$t("total"),
          value: "total"
        },
        { text: this.$t("pending"), value: "pendingReview" },
        { text: this.$t("reviewed2"), value: "reviewed" }
      ];
    }
  },
  methods: {
    openSimposium(item) {
      console.log(item);
      this.$router.push({
        name: "SymposiaDetail",
        params: { symposiaId: item.id, symposia: item }
      });
    }
  }
};
</script>

<style lang="scss" scoped>
</style>